import React, { useEffect } from "react";
import { Snackbar } from "@mui/joy";
import { JoySnackBarContext } from "./context";
import { keyframes } from "@mui/system";
import Button from "@mui/joy/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faUserTimes,
  faLock,
  faCheckCircle,
  faExclamationTriangle,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";

const icons = {
  UserNotFound: faUserTimes,
  WrongPassword: faLock,
  LoginSuccessful: faCheckCircle,
  LogOutSuccessful: faCheckCircle,
  LogOutError: faTimesCircle,
};

const inAnimation = keyframes`
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const outAnimation = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(0);
    opacity: 0;
  }
`;

//
//
//  write loader type, percentage,
//
//
//

const JoySnackBar = () => {
  const { joySnackBarData, JoySnackBarDispatcher } =
    React.useContext(JoySnackBarContext);
  const [xopen, setXOpen] = React.useState(false);

  const {
    vertical,
    horizontal,
    open,
    message,
    color,
    size,
    variant,
    iconColor,
    iconName,
  } = joySnackBarData || {};

  const animationDuration = 600;
  const animationDurationOut = 500;

  // render icon
  const renderIcon = (icon, color) => {
    const IconComponent = icons[icon];
    if (!IconComponent) {
      return null;
    }
    return (
      <FontAwesomeIcon
        icon={IconComponent}
        style={{ fontSize: "2.5vh", color: color }}
      />
    );
  };

  useEffect(() => {
    if (open) {
      setXOpen(true);
    }
  }, [open]);

  const handleClose = () => {
    setXOpen(false);
    setTimeout(() => {
      JoySnackBarDispatcher("CLOSE", {});
    }, 600);
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical, horizontal }}
      open={xopen}
      autoHideDuration={3600}
      key={vertical + horizontal}
      onClose={handleClose}
      color={color}
      size={size}
      variant={variant}
      animationDuration={animationDuration}
      startDecorator={renderIcon(iconName, iconColor)}
      endDecorator={
        <Button
          onClick={handleClose}
          color={color}
          size={size}
          variant={variant}
        >
          Dismiss
        </Button>
      }
      sx={{
        fontFamily: "Ubuntu, Arial, sans-serif",
        ...(xopen && {
          animation: `${inAnimation} ${animationDuration}ms forwards`,
        }),
        ...(!xopen && {
          animation: `${outAnimation} ${animationDurationOut}ms forwards`,
        }),
      }}
    >
      {message}
    </Snackbar>
  );
};

export default JoySnackBar;
